// extracted by mini-css-extract-plugin
export default {"form":"formCreate_form__zXh7d","imgUpload":"formCreate_imgUpload__q41te","formGroup2":"formCreate_formGroup2__dXM6j","formGroup":"formCreate_formGroup__QnR+p"};